import take from '../take.js';

export default function dropLast(n, xs) {
  return take(n < xs.length ? xs.length - n : 0, xs);
}


//////////////////
// WEBPACK FOOTER
// /opt/mybespokeroom/shared/~/ramda/es/internal/_dropLast.js
// module id = 776
// module chunks = 2 3 4 5 6 7 8 10